
import {
    ref,
    defineComponent,
    computed,
    watch,
    reactive,
    onMounted,
    getCurrentInstance,
} from 'vue'

export default defineComponent({
    name: 'MenuList',
    props: {
        node: {
            type: Object,
            default() {
                return {}
            },
        },
        parentNode: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    setup(props, { emit, attrs }) {
        const instance: any = getCurrentInstance()
        const getTop = () => {
            let topNodeItem = instance
            while (
                !topNodeItem.proxy ||
                (topNodeItem.proxy && !topNodeItem.proxy.menus)
            ) {
                topNodeItem = topNodeItem.parent
            }
            return topNodeItem
        }
        function checkedChange(node, checkedStatus) {
            // 把当前节点的子节点都设置成checke状态
            function setChecked(node: any) {
                node.checked = checkedStatus
                if (node.children && node.children.length) {
                    node.children.forEach((item: any) => {
                        setChecked(item)
                    })
                }
            }
            setChecked(node)
            return true
        }
        const changeChecked = (node: any) => {
            let topItem = getTop()
            // node.checked = !node.checked
            // 设置子节点的 checkbox 状态
            checkedChange(node, !node.checked)
            // topItem.emit('checkedChange', node)
            // 改变父节点的状态
            let parentNode: any = instance.props.parentNode
            let children = parentNode.children
            // 子节点选中的个数
            let selectedLength = 0
            if (children && children.length) {
                children.forEach((item: any) => {
                    if (item.checked) {
                        selectedLength++
                    }
                })
                // 设置父节点的选中状态
                if (selectedLength === children.length) {
                    parentNode.indeterminate = false
                    parentNode.checked = true
                } else if (selectedLength > 0) {
                    parentNode.indeterminate = true
                    parentNode.checked = false
                } else {
                    parentNode.indeterminate = false
                    parentNode.checked = false
                }
            }
        }
        const toggleExpand = (node: any) => {
            node.expand = !node.expand
        }
        onMounted(() => {})
        return {
            changeChecked,
            toggleExpand,
        }
    },
})
